import React from 'react';
import useStyle from './NgoModalPublicShop.style';
import { classNames } from '../../../../../../helpers/style/classNames';

interface NgoDescriptionViewProps {
  name: string;
  displayName: string;
  descriptions: string[];
  catchPhrases: string[];
  actions: string[];
}

const NgoDescriptionView = ({
  name,
  displayName,
  descriptions,
  catchPhrases,
  actions
}: NgoDescriptionViewProps) => {
  const classes = useStyle();
  return (
    <div>
      <div>
        <h3 className={classes.title}>Le principe</h3>
        <p>
          Lors de votre commande, vous pouvez faire un don en reversant 1 euro à
          une association choisie par l'élève. Nous sommes fiers d'offrir à nos
          élèves la possibilité de participer à des challenges au profit d'ONG.
          En plus des dons de nos clients, nous reversons 0,5% du chiffre
          d'affaires de l'élève à l'association de son choix. Ainsi, nous
          soutenons l'engagement de nos élèves tout en contribuant
          financièrement aux actions des ONG.
        </p>
      </div>
      <div className={classes.ngo}>
        <h3 className={classes.title}>L'ong choisit par l'élève</h3>
        <div className={classes.ngoContainer}>
          <div className={classNames([classes.image, classes[name]])}>
            <h2 className={classes.ngoName}>{displayName}</h2>
          </div>
          <div className={classes.content}>
            <div>
              {descriptions.map((description, index) => (
                <p key={index}>{description}</p>
              ))}
            </div>
            <div>
              {actions.map((action, index) => (
                <p key={index}>{action}</p>
              ))}
            </div>
            <div>
              {catchPhrases.map((catchPhrase, index) => (
                <p key={index}>{catchPhrase}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NgoDescriptionView;
